import {Injectable, Injector} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {map, Observable} from "rxjs";
import {TokenStorageService} from "../storage/token-storage.service";
import {environment} from "../../../environments/environment";

export interface IAppConfig {

  priceUrl: string,
  priceStreamingUrl: string
  priceAuthUrl: string,
  priceDomain: string,
  tradeDomain: string,
  feedProjectId: string,
  portalBO: string,
  portalAuth: string,
  projectVersions?: { [key: string]: string[] }

}
export interface RegionData {
  tradeStreamingUrl: string;
  omsProjectId: string;
  fixProjectId: string,
  externalProjectId: string,
  contactDetails: {
    addressLine1: string;
    addressLine2: string;
    website: string;
    phone: string;
    email: string;
  };
  disclaimer: string;
}
@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private appConfig: IAppConfig | undefined;
  private asiaConfig: RegionData | undefined;
  private menaConfig: RegionData | undefined;

  tradeDomain: string | undefined;
  priceDomain: string | undefined;
  constructor(private injector: Injector, private http: HttpClient, private tokenStorage: TokenStorageService) {
  }

  loadAppConfig = (): Promise<any> => {
    // Per-environment config file, e.g. app-config.dev.json / app-config.staging.json / app-config.production.json
    const envConfigUrl = `/assets/app-config.${environment.name}.json`;
    return this.http.get(envConfigUrl).toPromise()
      .then((data: any) => {
        this.saveAppConfig(<IAppConfig>data);
      })
      .catch((error: any) => {
        // Fallback to the legacy single config file so existing deployments keep working
        console.warn(`Could not load ${envConfigUrl}, falling back to /assets/app-config.json`, error);
        return this.http.get('/assets/app-config.json').toPromise()
          .then((data: any) => {
            this.saveAppConfig(<IAppConfig>data);
          })
          .catch((fallbackError: any) => {
            console.error('Error loading app config:', fallbackError);
          });
      });
  };

  loadMenaConfig(): Promise<any> {
    return this.http.get('/assets/mena-config.json').toPromise()
      .then((data: any) => {
        this.saveMenaConfig(<RegionData>data);
      })
      .catch((error: any) => {
        console.error('Error loading app config:', error);
      });
  }

  loadAsiaConfig(): Promise<any> {
    return this.http.get('/assets/asia-config.json').toPromise()
      .then((data: any) => {
        this.saveAsiaConfig(<RegionData>data);
      })
      .catch((error: any) => {
        console.error('Error loading app config:', error);
      });
  }

  private saveAppConfig(data:IAppConfig){
    this.appConfig = data;
    this.tradeDomain = this.appConfig?.tradeDomain;
    this.priceDomain = this.appConfig?.priceDomain;
    this.tokenStorage.saveUserType( (window.location.hostname == this.priceDomain) ? "FEED" : (window.location.hostname == this.tradeDomain) ? "OMS" : "");

  }
  get getCommonConfig() {
    return this.appConfig;
  }

  saveMenaConfig(data:RegionData){
    this.menaConfig = data;
  }
  get getMenaConfig() {
    return this.menaConfig;
  }

  saveAsiaConfig(data:RegionData){
    this.asiaConfig = data;
  }
  get getAsiaConfig() {
    return this.asiaConfig;
  }

}
